__turbopack_context__.v({
  "card_container": "SkillsCard-module-scss-module__nqihea__card_container",
  "cards": "SkillsCard-module-scss-module__nqihea__cards",
  "desc": "SkillsCard-module-scss-module__nqihea__desc",
  "heading": "SkillsCard-module-scss-module__nqihea__heading",
  "iconBox": "SkillsCard-module-scss-module__nqihea__iconBox",
  "title": "SkillsCard-module-scss-module__nqihea__title",
  "wrapper": "SkillsCard-module-scss-module__nqihea__wrapper",
});
